var map = {
	"./audio/bg.mp3": "TshJ",
	"./audio/bg.ogg": "aPr9",
	"./audio/bg.wav": "GENn",
	"./audio/hero-cv-1.mp3": "Rtzf",
	"./audio/hero-cv-1.ogg": "mmVA",
	"./audio/hero-cv-1.wav": "zilZ",
	"./audio/hero-cv-2.mp3": "fN2G",
	"./audio/hero-cv-2.ogg": "5WsH",
	"./audio/hero-cv-2.wav": "X0xQ",
	"./audio/hero-cv-3.mp3": "ZTLm",
	"./audio/hero-cv-3.ogg": "aRj2",
	"./audio/hero-cv-3.wav": "uATz",
	"./audio/hero-cv-4.mp3": "1Gso",
	"./audio/hero-cv-4.ogg": "irzU",
	"./audio/hero-cv-4.wav": "10ev",
	"./audio/hero-cv-5.mp3": "pcny",
	"./audio/hero-cv-5.ogg": "VpjS",
	"./audio/hero-cv-5.wav": "sjhT",
	"./audio/hero-cv-6.mp3": "8ZLL",
	"./audio/hero-cv-6.ogg": "mRGU",
	"./audio/hero-cv-6.wav": "QsYI",
	"./audio/hero-cv-7.mp3": "EQht",
	"./audio/hero-cv-7.ogg": "ddCI",
	"./audio/hero-cv-7.wav": "yljO",
	"./audio/hero-cv-8.mp3": "rD2I",
	"./audio/hero-cv-8.ogg": "C6Ih",
	"./audio/hero-cv-8.wav": "XMEO",
	"./audio/noplay.png": "3MBF",
	"./audio/play.png": "RTHZ",
	"./game-rating.jpeg": "uHnm",
	"./h5/imgs/bg-1-hero.png": "q8Am",
	"./h5/imgs/bg-1.jpg": "qOcM",
	"./h5/imgs/bg-2-hero.png": "dAOT",
	"./h5/imgs/bg-2.jpg": "NA/H",
	"./h5/imgs/bg-3.jpg": "1nPs",
	"./h5/imgs/bg-4.jpg": "teTo",
	"./h5/imgs/bg-5.jpg": "IW9i",
	"./h5/imgs/bg-bottom.png": "xf9z",
	"./h5/imgs/bg-top-tool.png": "Mh9M",
	"./h5/imgs/btn-menu.png": "d4T3",
	"./h5/imgs/feature-navigation.png": "1p9z",
	"./h5/imgs/hero-1.png": "AlYW",
	"./h5/imgs/hero-2.png": "UnMJ",
	"./h5/imgs/hero-3.png": "qX8I",
	"./h5/imgs/hero-4.png": "CJq1",
	"./h5/imgs/hero-5.png": "kMYb",
	"./h5/imgs/hero-6.png": "TwcY",
	"./h5/imgs/hero-7.png": "ymI4",
	"./h5/imgs/hero-8.png": "JhbH",
	"./h5/imgs/menu-close.png": "fXTp",
	"./h5/imgs/menu-line.png": "6mps",
	"./h5/imgs/section-next.png": "I/Be",
	"./pc/imgs/baha.png": "/AQJ",
	"./pc/imgs/bg-2.jpg": "em/3",
	"./pc/imgs/bg-3.jpg": "FQ6X",
	"./pc/imgs/bg-4.jpg": "1JK3",
	"./pc/imgs/bg-5.jpg": "Cc0D",
	"./pc/imgs/bg-lang.png": "ycuO",
	"./pc/imgs/bg-option.png": "T1xh",
	"./pc/imgs/facebook.png": "Mi2w",
	"./pc/imgs/feature-navigation.png": "u6xz",
	"./pc/imgs/hero-1.png": "RJm1",
	"./pc/imgs/hero-2.png": "Z2Wm",
	"./pc/imgs/hero-3.png": "pKQQ",
	"./pc/imgs/hero-4.png": "YGbZ",
	"./pc/imgs/hero-5.png": "7zno",
	"./pc/imgs/hero-6.png": "1zrG",
	"./pc/imgs/hero-7.png": "M3p2",
	"./pc/imgs/hero-8.png": "KAr3",
	"./pc/imgs/hero-navigation.png": "/7FM",
	"./pc/imgs/lang-tw.png": "nxDU",
	"./pc/imgs/lang-zh.png": "dpj/",
	"./pc/imgs/play-btn.png": "+/OH",
	"./pc/imgs/vedio-bg-1.png": "9wL0",
	"./pc/vedio/bg-1.webm": "Y7CA",
	"./pc/vedio/首页组简体.webm": "TN7k",
	"./pc/vedio/首页组繁体.webm": "FHPt",
	"./vedio/game.mp4": "Jsi6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xkYq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common ^\.\/.*$
// module id = xkYq
// module chunks = 13